import { Injectable } from "@angular/core";
import { BaseService } from "../base.service";
import { environment } from "src/environments/environment";
import { tap, catchError } from "rxjs/operators";
import { AuthenticateService } from "../authentication/authenticate.service";
import { Observable, BehaviorSubject } from "rxjs";
import { MessageService } from "../message/message.service";
import { PatientProfile } from "src/app/models/user";

@Injectable({
  providedIn: "root",
})
export class ChatService {
  private initialized = false;
  chatUser = new BehaviorSubject(null);
  constructor(
    public baseService: BaseService,
    public authenticateService: AuthenticateService,
    public messageService: MessageService
  ) {}

  getChat(userId: number): Observable<ChatUser> {
    const url = `${environment.serviceURL}/v2/chat/users/${userId}`;

    return this.baseService.get(url).pipe(
      tap(async (res: ChatUser) => {
        if (res) {
          this.postChatUser(res);
        }
      }),
      catchError((e) => {
        console.log(e);
        throw e;
      })
    );
  }
  createChat(req: ChatCreateRequest): Observable<ChatUser> {
    const url = `${environment.serviceURL}/v2/chat/users`;
    return this.baseService.post(url, req).pipe(
      tap(async (res: ChatUser) => {
        if (res) {
          this.postChatUser(res);
        }
      }),
      catchError((e) => {
        console.log(e);
        throw e;
      })
    );
  }
  private postChatUser(res: ChatUser) {
    this.initialized = true;
    this.chatUser.next(res);
    this.fetchGenericSettings(res);
  }

  private sendDeviceDetail(userId: number, dd: DeviceDetail) {
    this.baseService
      .post(`${environment.serviceURL}/v1/messaging/devices/${userId}`, dd)
      .subscribe((res) => {});
  }
  fetchGenericSettings(chatUser: ChatUser) {
    this.baseService
      .post(`${environment.apiURL}/settings/generic`, {})
      .subscribe((res) => {
        this.messageService.connect(chatUser, res.generic.mqtt_connect_flag);

        //  {
        //   settingCheck: res.generic.mqtt_connect_flag,
        //   generic: res.generic,
        //   timer: res.generic.offline_timer * 1000,
        // },
        // this.sendDeviceDetail(1, {
        //   device: this.deviceInfo.platform,
        //   deviceName: this.deviceInfo.model,
        //   osVersion: this.deviceInfo.osVersion,
        //   appVersion: this.deviceInfo.appVersion,
        // } as DeviceDetail);
      });
  }
}

export interface ChatCreateRequest {
  id: number;
  phoneNo: number;
  patientProfile: PatientProfile;
}
export interface ChatUser {
  id: string;
  externalUserId: number;
  externalUserIdSt: string;
  firstName: string;
  lastName: string;
  fullName: string;
  countryCode: number;
  phone: string;
  chatUserId: string;
  chatToken: string;
  chatRoom: string;
  chatBoxEnabled: boolean;
  patientId: number;
}

export interface DeviceDetail {
  device: string;
  deviceName: string;
  osVersion: string;
  appVersion: string;
}
export interface GenericSetting {
  mqtt_connect_flag: boolean;
  offline_timer: number;
}
